import React from "react";

interface DiligentLogoProps {
  width?: string | number;
  height?: string | number;
}

const DiligentLogo: React.FC<DiligentLogoProps> = ({
  width = "22.9px",
  height = "32px",
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 30 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M28.8695 15.9789C28.8695 20.8942 27.1175 24.9439 24.1224 27.7432C24.0879 27.7735 24.062 27.8054 24.0275 27.8358C21.7998 29.8809 18.8952 31.24 15.5134 31.7596L15.2849 31.5251L20.3252 2.32436L20.5149 1.79028C25.6746 4.32898 28.8695 9.39624 28.8695 15.9789Z" 
        fill="#EE312E"
      />
      <path 
        d="M20.5164 1.79175L0 17.1079V31.4759V31.9999H12.3544C13.4481 31.9999 14.5016 31.916 15.5149 31.7596C15.5149 31.7611 20.5164 1.79175 20.5164 1.79175Z" 
        fill="#D3222A"
      />
      <path 
        d="M20.5164 1.79185L20.3741 2.00461L0.106355 17.2078L0 17.108C0 17.108 0 17.1036 0 17.0993V0H12.307C13.1564 0 13.9799 0.0492107 14.7776 0.146185H14.8077C16.8227 0.386449 18.6782 0.914741 20.3382 1.70645C20.4043 1.7383 20.5164 1.79185 20.5164 1.79185Z" 
        fill="#AF292E"
      />
    </svg>
  );
};

export default DiligentLogo; 